import { saveAs } from 'file-saver'
import { ElMessage, ElNotification } from 'element-plus'

/**
 * 通用文件下载方法
 * @param fileUrl - 文件的URL
 * @param fileName - 下载时使用的文件名 (可选)
 */
export const downloadFile = async (fileUrl: string, fileName = 'download') => {
  let notification: any = null
  try {
    // eslint-disable-next-line no-use-before-define
    const className = `download-${randomId()}`
    notification = ElNotification({
      title: '下载中',
      message: '准备开始下载...',
      duration: 0, // 0表示不自动关闭
      type: 'info',
      customClass: className,
      position: 'top-right',
      showClose: false,
    })
    // eslint-disable-next-line no-use-before-define
    notification.update = updateNotification(className)
    const xhr = new XMLHttpRequest()
    xhr.open('GET', fileUrl, true)
    xhr.responseType = 'blob'

    xhr.onprogress = event => {
      if (event.lengthComputable) {
        const percentComplete = (event.loaded / event.total) * 100
        notification.update({
          message: `下载进度: ${percentComplete.toFixed(2)}%`,
        })
      }
    }

    xhr.onload = () => {
      if (xhr.status === 200) {
        saveAs(xhr.response, fileName)
        notification.close()
      } else {
        throw new Error(`下载文件失败: ${xhr.statusText}`)
      }
    }

    xhr.onerror = () => {
      throw new Error('文件下载请求失败')
    }

    xhr.send()
  } catch (error) {
    console.error('文件下载失败:', error)
    if (notification) {
      notification.update({
        title: '下载失败',
        message: `文件下载失败:请稍后重试!`,
      })
      setTimeout(() => {
        notification.close()
      }, 1000)
    } else {
      ElMessage.error(`文件下载失败: ${(error as Error).message}`)
    }
  }
}
function randomId() {
  return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)
}

function updateNotification(className: string) {
  const notification = document.querySelector(`.${className}`) as HTMLElement
  return (info: { title?: string; message?: string }) => {
    if (info.title) {
      notification.querySelector('.el-notification__title')!.textContent = info.title
    }
    if (info.message) {
      notification.querySelector('.el-notification__content')!.textContent = info.message
    }
  }
}
